import { TState } from '~/src/store';

import { IPopupData } from './index';

export const getPopupData = (state: TState, popupId: string): IPopupData => {
    const popup = state.popups[popupId];

    return popup || {};
};
